import React from 'react';
import { AlertTriangle, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface ConfirmDialogProps {
  isOpen: boolean;
  title: string;
  description: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
  variant?: 'danger' | 'primary';
}
export function ConfirmDialog({
  isOpen,
  title,
  description,
  confirmText = 'Bevestigen',
  cancelText = 'Annuleren',
  onConfirm,
  onCancel,
  variant = 'primary'
}: ConfirmDialogProps) {
  return <AnimatePresence data-id="element-3201" data-mp="tbo4rj69yygt">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={onCancel} data-id="element-3202" data-mp="ode62ylcdfqg">
          <motion.div initial={{
        scale: 0.95,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} exit={{
        scale: 0.95,
        opacity: 0
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 24
      }} onClick={e => e.stopPropagation()} className="bg-card border border-border rounded-2xl w-full max-w-sm overflow-hidden shadow-xl" data-id="element-3203" data-mp="2dtdluyjgu3f2">
            <div className="p-6 space-y-4" data-id="element-3204" data-mp="135mpzc5zewja">
              <div className="flex items-start justify-between" data-id="element-3205" data-mp="134bndfo9vutr">
                <h3 className="text-lg font-semibold text-foreground" data-id="element-3206" data-mp="of5qvzgtkipk">
                  {title}
                </h3>
                <button onClick={onCancel} className="text-muted-foreground hover:text-foreground transition-colors rounded-lg p-1 focus:outline-none focus:ring-2 focus:ring-border" data-id="element-3207" data-mp="tdz37okde3o5">
                  <X className="w-5 h-5" data-id="element-3208" data-mp="1lxfn9is333wt" />
                </button>
              </div>
              <p className="text-muted-foreground text-sm" data-id="element-3209" data-mp="1vph1rvqjj4td">{description}</p>
            </div>
            <div className="p-4 bg-background/50 flex gap-3" data-id="element-3210" data-mp="1qt9y69lma5el">
              <button onClick={onCancel} className="flex-1 px-4 py-2 bg-muted hover:bg-muted/80 text-foreground rounded-xl font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-border" data-id="element-3211" data-mp="1mpu15c5my31d">
                {cancelText}
              </button>
              <button onClick={onConfirm} className={`flex-1 px-4 py-2 rounded-xl font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-background ${variant === 'danger' ? 'bg-destructive hover:bg-destructive/80 text-destructive-foreground focus:ring-destructive' : 'bg-primary hover:bg-primary/80 text-primary-foreground focus:ring-primary'}`} data-id="element-3212" data-mp="180xt3f3kwq0r">
                {confirmText}
              </button>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}